<template>
  <div class="page-box">
    <krpanoView @krpanoReady="panoReady"></krpanoView>
    <immersionStyle v-if="viewModel == 2"></immersionStyle>
    <menuArea :krpano="krpano" :uiToggleVar="uiToggleVar" :sceneName="sceneName"></menuArea>

    <!-- <div class="logo-icon" :class="{ 'ui-hide': !uiToggleVar }"></div> -->

    <!-- <div class="model-change" @click="changView">
      {{ viewModel == 1 ? "护目镜模式" : "纯净模式" }}
    </div> -->
    <bottomOption :krpano="krpano" @candleClick="candleClick" @uiToggle="uiToggle"></bottomOption>
    <imgSwiper class="swiper-box" v-if="imgHotspotShow" @closeSwiper="closeSwiper" :baseFile="baseFile"
      :imgNowIndex="imgNowIndex" :imgTotal="imgTotal" :baseUrl="baseUrl"></imgSwiper>
    <textHotpot :textIndex="textIndex" class="hotspot-text-box" v-if="textHotpotShow" @closeHot="closeTextHot">
    </textHotpot>
    <panoMap :uiToggleVar="uiToggleVar" :krpano="krpano" :sceneName="sceneName"></panoMap>
    <!-- <flowerWall v-if="flowerShow" @toggleFlower="toggleFlower"></flowerWall> -->
    <videoHotspot v-if="videoShow" @closeVideo="closeVideo" :guid="guid"></videoHotspot>
    <liveHotspot v-if="LiveShow" @closeLive="closeLive" :zhiboId="zhiboId"></liveHotspot>
    <audioHotspot v-if="audioShow" @closeAudio="closeAudio" :audioSrc="audioSrc"></audioHotspot>
    <leaveMessage></leaveMessage>
    <messageScroll />
    <!-- <div class="guide-box" v-if="guideShow" @click="jump">
      <div class="jump-title">跳过</div>
    </div> -->
    <canwser />
    <actualTimePopularity />
    <guidePage v-if="guideShow" @iknow="handleIknow" />

  </div>
</template>

<script>
import krpanoView from "@/components/krpanoView";
import imgSwiper from "@/components/imgSwiper";
import immersionStyle from "@/components/immersionStyle";
import bottomOption from "@/components/bottomOption";
import menuArea from "@/components/menu";
import textHotpot from "@/components/textHotspot";
import videoHotspot from "@/components/videoHotspot";
import audioHotspot from "@/components/audioHotspot";
import liveHotspot from "@/components/liveHotspot";
import panoMap from "@/components/panoMap";
// import flowerWall from "@/components/flowerWall";
import leaveMessage from "@/components/leaveMessage";
import guidePage from "@/components/guidePage";
import canwser from "@/components/canswer/index";
import actualTimePopularity from "@/components/actualTimePopularity/index";
import messageScroll from '@/components/messageScroll';

export default {
  components: {
    imgSwiper,
    krpanoView,
    immersionStyle,
    bottomOption,
    menuArea,
    textHotpot,
    panoMap,
    videoHotspot,
    leaveMessage,
    audioHotspot,
    guidePage,
    canwser,
    actualTimePopularity,
    messageScroll,
    liveHotspot
  },
  data() {
    return {
      viewModel: 1,
      krpano: "",
      imgHotspotShow: false,
      textHotpotShow: false,
      mapShow: false,
      textIndex: "",
      flowerShow: false,
      imgNowIndex: "",
      imgTotal: "",
      baseUrl: "",
      baseFile: "",
      uiToggleVar: true,
      videoShow: false,
      guid: "",
      sceneName: "",
      guideShow: true,
      audioShow: false,
      audioSrc: "",
      LiveShow: false,
      zhiboId: ""
    };
  },
  watch: {
    sceneName(val) {

    },
  },
  methods: {
    changView() {
      if (this.viewModel == 1) {
        this.viewModel = 2;
      } else {
        this.viewModel = 1;
      }
    },
    panoReady(pano) {
      this.krpano = pano;
    },
    showImgHotspot(baseFile, baseUrl, nowIndex, total) {
      this.imgHotspotShow = true;
      this.baseFile = baseFile;
      this.baseUrl = baseUrl;
      this.imgNowIndex = nowIndex;
      this.imgTotal = total;
    },
    closeSwiper() {
      this.imgHotspotShow = false;
      this.baseFile = "";
      this.baseUrl = "";
      this.imgNowIndex = "";
      this.imgTotal = "";
    },
    showTextHotspot(textIndex) {
      this.textHotpotShow = true;
      this.textIndex = textIndex;
    },
    closeTextHot() {
      this.textHotpotShow = false;
      this.textIndex = "";
    },
    mapToggle(showOrHide) {
      this.mapShow = showOrHide;
    },
    toggleFlower(flowerShow) {
      this.flowerShow = flowerShow;
    },
    candleClick() {
      this.flowerShow = true;
    },
    uiToggle(uiToggle) {
      this.uiToggleVar = uiToggle;
    },
    mediaOpenAudio() {
      var audio = document.querySelector("#audio");

      if (!audio.paused) {
        audio.pause();

      }
    },
    mediaCloseAudio() {
      var audio = document.querySelector("#audio");
      if (audio.paused && sessionStorage.bgmusic == "play" && sessionStorage.bgmusicEnd == "false") {
        audio.play();
        audio.addEventListener("ended", function () {
          sessionStorage.bgmusicEnd = "true"
        })
      }
    },
    closeVideo() {
      this.videoShow = false;
      this.mediaCloseAudio();
    },
    showVideo(guid) {
      this.guid = guid;
      this.videoShow = true;
      this.mediaOpenAudio()
    },
    closeLive() {
      this.LiveShow = false;
      this.mediaCloseAudio();
    },
    showLive(zhiboId) {
      this.zhiboId = zhiboId;
      this.LiveShow = true;
      this.mediaOpenAudio()
    },
    openAudio(src) {
      this.audioSrc = src;
      this.audioShow = true;
      this.mediaOpenAudio()
    },
    closeAudio() {
      this.audioShow = false;
      this.mediaCloseAudio();
    },
    locationStart(audioSrc) {
      this.sceneName = this.krpano.get("xml.scene");
      var audio = document.querySelector("#audio");
      if (this.sceneName) {
        var nowSceneName = this.sceneName.split("_");

        // var newSrc = "audio/" + nowSceneName[1] + "_" + nowSceneName[2] + "_" + nowSceneName[3] + ".mp3";
        // var newSrc = "audio/" + nowSceneName[1] + "_" + nowSceneName[2] + ".mp3";
        var newSrc = ""
        if (audioSrc) {
          newSrc = "audio/" + audioSrc + ".mp3"
        } else {
          newSrc = ""
        }
        if (audio.src.indexOf(newSrc) > -1 && newSrc != "") {

          return;
        } else {
          sessionStorage.bgmusicEnd = "false"
        }

        audio.setAttribute("src", newSrc);
        if (sessionStorage.bgmusic == "play" && sessionStorage.bgmusicEnd == "false") {
          audio.play();
          audio.addEventListener("ended", function () {
            sessionStorage.bgmusicEnd = "true"
          })
        } else {
          audio.pause();
        }
      } else {
        audio.src = "";
      }
    },
    jump() {
      this.guideShow = false;
      var audio = document.querySelector("#audio");
      audio.play();

      sessionStorage.bgmusic = "play";
    },
    // 引导页面 - 我知道了
    handleIknow() {
      this.guideShow = false;
      var audio = document.querySelector("#audio");
      audio.play();

      sessionStorage.bgmusic = "play";
    }
  },
  mounted() {
    window.showTextHotspot = this.showTextHotspot;
    window.popImg = this.showImgHotspot;
    window.popVideo = this.showVideo;
    window.popAudio = this.openAudio;
    window.popLive = this.showLive;
    window.locationStart = this.locationStart;
    window.openFlower = this.toggleFlower;
  },
  created() {
    sessionStorage.bgmusic = "play"
    sessionStorage.bgmusicEnd = "false"
  },

};
</script>

<style lang="scss" scoped>
.page-box {
  width: 100%;
  height: 100%;
  position: relative;

  .swiper-box {
    position: absolute;
    top: 0;
  }

  @mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .top-nav {
    width: 100%;
    height: 1.42rem;
    background-image: url("../../../assets/img/top-nav.png");
    @include background-com();
    position: absolute;
    top: 0;
    left: 0;
  }

  .model-change {
    width: 1.2rem;
    height: 0.48rem;
    text-align: center;
    line-height: 0.48rem;
    color: #ffffff;
    font-size: 0.16rem;
    border-radius: 0.24rem;
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    background-color: #8f0000;
    cursor: pointer;
  }

  .guide-box {
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/img/guide.png");
    @include background-com();
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000000;

    .jump-title {
      color: #ffffff;
      font-size: 0.3rem;
      position: absolute;
      padding-bottom: 0.1rem;
      border-bottom: 1px solid #ffffff;
      right: 0.5rem;
      bottom: 0.5rem;
      cursor: pointer;
    }
  }
}
</style>